export default __webpack_public_path__ + "static/schema-7425304f2305e1e15f3d012dfdd4d863.svg";